import Swiper, { Navigation } from 'swiper';
import $ from 'jquery';
import { gsap } from 'gsap'


export function timelineSlider() {
    $('.timeline-slider__wrapper').each(function () {
        const block = $(this);
        const sliderElement = block.find('.timeline-slider__slider').get(0);
        const navItems = block.find('.timeline-slider__nav-item-btn');

        block.find('.read-more-btn').text('..view more');
        block.find('.read-less-btn').text('..view less');

        const imagesSlider = new Swiper(sliderElement, {
            loop: false,
            slidesPerView: 1.3,
            centeredSlides: true,
            slideToClickedSlide: true,
            //autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            modules: [Navigation],
            on: {
                slideChange: function () {
                    updateArrowsState(block, this.isBeginning, this.isEnd);
                },
            },
        });

        // Initial arrow state
        updateArrowsState(block, imagesSlider.isBeginning, imagesSlider.isEnd);

        // Add active class to the first nav item
        navItems.eq(0).addClass('active');

        // Handle navigation item click
        navItems.on('click', function () {
            const index = $(this).data('index');
            imagesSlider.slideTo(index);
        });

    
        // Update navigation and content visibility on slide change
        imagesSlider.on('slideChange', function () {
            const activeIndex = imagesSlider.activeIndex;

            // Update active navigation item
            navItems.removeClass('active');
            navItems.filter(`[data-index="${activeIndex}"]`).addClass('active');

            // Collapse all extended content and reset "read more" buttons
            block.find('.content-extended').slideUp();
            block.find('.read-more-btn').show();
        });

        let navWrapper = block.find('.timeline-slider__nav-block');
        let nav = navWrapper.find('.timeline-slider__nav-wrapper');
        let navNext = block.find('.timeline-slider__nav-arrow--next');
        let navPrev = block.find('.timeline-slider__nav-arrow--prev');

        let wrapperWidth = navWrapper.outerWidth();
        let navWidth = nav.outerWidth();

        let currentX = 0;
        let step = wrapperWidth * 0.6; // scroll 60% of visible width each time

        navPrev.hide(); // initially hidden

        function updateArrows() {
            navPrev.toggle(currentX < 0);
            navNext.toggle(Math.abs(currentX) + wrapperWidth < navWidth);
        }

        navNext.on('click', function () {
            if (Math.abs(currentX) + wrapperWidth < navWidth) {
                currentX -= step;
                if (Math.abs(currentX) + wrapperWidth > navWidth) {
                    currentX = -(navWidth - wrapperWidth);
                }

                gsap.to(nav, { x: currentX, duration: 0.5, ease: 'power2.out' });
                updateArrows();
            }
        });

        navPrev.on('click', function () {
            if (currentX < 0) {
                currentX += step;
                if (currentX > 0) currentX = 0;

                gsap.to(nav, { x: currentX, duration: 0.5, ease: 'power2.out' });
                updateArrows();
            }
        });

        // Optionally update on resize
        $(window).on('resize', function () {
            wrapperWidth = navWrapper.outerWidth();
            navWidth = nav.outerWidth();
            updateArrows();
        });

        
    });

    /**
     * Update the state of navigation arrows based on the current slide position.
     * @param {jQuery} block - The wrapper block for the slider.
     * @param {boolean} isBeginning - Whether the current slide is the first slide.
     * @param {boolean} isEnd - Whether the current slide is the last slide.
     */
    function updateArrowsState(block, isBeginning, isEnd) {
        const arrow = block.find('.slider-arrow');
        if (isBeginning) {
            arrow.addClass('first');
        } else {
            arrow.removeClass('first');
        }

        if (isEnd) {
            arrow.addClass('last');
        } else {
            arrow.removeClass('last');
        }
    }
}
